import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import {
    GeniusScoreboardWrapper,
    GeniusScoreboardIframe,
} from 'src/domains/sportsbook/webview/components/scoreboards/genius/GeniusScoreboard.style';
import { getGeniusWidgetConfig } from 'src/domains/sportsbook/webview/components/scoreboards/genius/getGeniusWidgetConfig';
import { buildGeniusGameTrackerUrl } from 'src/domains/sportsbook/webview/components/scoreboards/genius/buildGeniusGameTrackerUrl';

const GAME_TRACKER_MIN_HEIGHT_PX = 110;

interface GeniusGameTrackerPropsType {
    event: EventModel;
}

export const GeniusGameTracker = observer('GeniusGameTracker', ({ event }: GeniusGameTrackerPropsType) => {
    const common = useCommon();
    const config = ConfigComponents.get(common).config;
    const widgetConfig = getGeniusWidgetConfig(event, config);

    if (widgetConfig === null || widgetConfig.kind !== 'gameTracker') {
        return null;
    }

    const { geniusScoreboard, fixtureId } = widgetConfig;
    const iframeUrl = buildGeniusGameTrackerUrl(
        geniusScoreboard.baseUrl,
        geniusScoreboard.productName,
        fixtureId,
        event
    );

    return (
        <GeniusScoreboardWrapper
            minHeight={GAME_TRACKER_MIN_HEIGHT_PX}
            data-test='genius-game-tracker'
        >
            <GeniusScoreboardIframe
                src={iframeUrl}
                title={`Genius Game Tracker for Event ${fixtureId}`}
                loading='lazy'
                allowFullScreen
                referrerPolicy='no-referrer-when-downgrade'
                data-test='genius-game-tracker-iframe'
                minHeight={GAME_TRACKER_MIN_HEIGHT_PX}
            />
        </GeniusScoreboardWrapper>
    );
});
